import {
  EffectiveDateRangeAccessRulePayload,
  PersistedEffectiveDateRangeAccessRulePayload,
  MaxDaysAccessRulePayload,
  PersistedMaxDaysAccessRulePayload,
  BlackoutDateRangeAccessRulePayload,
  PersistedBlackoutDateRangeAccessRulePayload,
  BlackoutDayOfWeekAccessRulePayload,
  PersistedBlackoutDayOfWeekAccessRulePayload,
} from "../models";

import {
  formatApiEndOfDay,
  formatApiStartOfDay,
  formatApiTime,
} from "./accessRuleRequestMapper";

export const mapEffectiveDateRange = (
  r: any,
): EffectiveDateRangeAccessRulePayload => ({
  effectiveDateStart: formatApiStartOfDay(r.effectiveDateStart!),
  effectiveDateEnd: formatApiEndOfDay(r.effectiveDateEnd!),
  effectiveTimeSlotStart: formatApiTime(r.effectiveTimeSlotStart!),
  effectiveTimeSlotEnd: formatApiTime(r.effectiveTimeSlotEnd!),
});

export const mapEffectiveDateRangeUpdate = (
  r: any,
): PersistedEffectiveDateRangeAccessRulePayload => ({
  liftAccessRuleId: r.liftAccessRuleId!,
  ...mapEffectiveDateRange(r),
});

export const mapMaxDays = (r: any): MaxDaysAccessRulePayload => ({
  numberOfDays: r.numberOfDays!,
  sharedUsage: r.sharedUsage,
});

export const mapMaxDaysUpdate = (
  r: any,
): PersistedMaxDaysAccessRulePayload => ({
  liftAccessRuleId: r.liftAccessRuleId!,
  ...mapMaxDays(r),
});

export const mapBlackoutDateRange = (
  r: any,
): BlackoutDateRangeAccessRulePayload => ({
  blackoutDateStart: formatApiStartOfDay(r.blackoutDateStart!),
  blackoutDateEnd: formatApiEndOfDay(r.blackoutDateEnd!),
  blackoutTimeSlotStart: formatApiTime(r.blackoutTimeSlotStart!),
  blackoutTimeSlotEnd: formatApiTime(r.blackoutTimeSlotEnd!),
});

export const mapBlackoutDateRangeUpdate = (
  r: any,
): PersistedBlackoutDateRangeAccessRulePayload => ({
  liftAccessRuleId: r.liftAccessRuleId!,
  ...mapBlackoutDateRange(r),
});

export const mapBlackoutDayOfWeek = (
  r: any,
): BlackoutDayOfWeekAccessRulePayload => ({
  dayOfWeekId: r.dayOfWeekId!,
  blackoutTimeSlotStart: formatApiTime(r.blackoutTimeSlotStart!),
  blackoutTimeSlotEnd: formatApiTime(r.blackoutTimeSlotEnd!),
});

export const mapBlackoutDayOfWeekUpdate = (
  r: any,
): PersistedBlackoutDayOfWeekAccessRulePayload => ({
  liftAccessRuleId: r.liftAccessRuleId!,
  ...mapBlackoutDayOfWeek(r),
});

export const mapDeletedIds = (deleted: any[]) =>
  deleted
    .map((r) => r.liftAccessRuleId)
    .filter((id): id is number => id != null);
